import { Cookies } from 'react-cookie';

import { AddLocationFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface CreateLocationProps {
  plan: AddLocationFormValues;
  slug: string;
}

export const postLocationOnMap = async ({ plan, slug }: CreateLocationProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.post(`v1/floor-plans/${slug}/locations/`, plan, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
